import type {
	AgentProfile,
	AgentProfileCompany,
	AgentProfilePortfolio,
	AgentProfileTransactions
} from '~/core/entities/agentProfile/AgentProfile';
import type { AgentHighlightItem } from '~/utils/agentProfileHighlights';

import { buildAgentHighlights } from '~/utils/agentProfileHighlights';
import { defineStore } from 'pinia';

export const useAgentProfileStore = defineStore('AgentProfileStore', () => {
	const slug = shallowRef<string | null>(null);
	const profile = shallowRef<AgentProfile | null>(null);

	const hasProfile = computed<boolean>(() => profile.value !== null);
	const company = computed<AgentProfileCompany | null>(
		() => profile.value?.company ?? null
	);
	const portfolio = computed<AgentProfilePortfolio | null>(
		() => profile.value?.portfolio ?? null
	);
	const transactions = computed<AgentProfileTransactions | null>(
		() => profile.value?.transactions ?? null
	);
	const highlights = computed<AgentHighlightItem[]>(() =>
		buildAgentHighlights(profile.value, undefined, 'performance')
	);
	const heroHighlights = computed<AgentHighlightItem[]>(() =>
		buildAgentHighlights(profile.value, undefined, 'hero')
	);

	function setSlug(value: string | null) {
		slug.value = value;
	}

	function setProfile(value: AgentProfile | null) {
		profile.value = value;
	}

	function reset() {
		slug.value = null;
		profile.value = null;
	}

	return {
		profile,
		hasProfile,
		slug,
		company,
		portfolio,
		transactions,
		highlights,
		heroHighlights,
		setSlug,
		setProfile,
		reset
	};
});
